<template>
  <div class="register-container">
    <div :style="{width: isMobile() ? '90%' : '30%', margin: '50px auto'}" class="register-wrapper">
      <el-card class="register-card">
        <h2 style="text-align: center; margin-bottom: 30px; font-size: 24px;">用户注册</h2>
        <!-- 注册表单 -->
        <avue-form
            ref="form"
            v-model="data"
            :option="option"
            @submit="submit"
            @keyup.enter.native="handleEnterKey"
            class="register-form"
        >
          <!-- 协议字段自定义插槽：独立Checkbox + 协议链接 -->
          <template slot="agreeProtocol" slot-scope="scope">
            <el-checkbox
                v-model="data.agreeProtocol"
                class="protocol-checkbox"
            ></el-checkbox>
            <span class="protocol-text">
              我已阅读并同意
              <a
                  @click.prevent="openProtocol('AgreementRegister.html')"
                  class="protocol-link"
              >
                《平台第三方注册协议》
              </a>
              <a
                  @click.prevent="openProtocol('PrivacyPolicy.html')"
                  class="protocol-link"
              >
                《平台隐私条款》
              </a>
              <a
                  @click.prevent="openProtocol('FeeStandard.html')"
                  class="protocol-link"
              >
                《平台文章发布收费标准》
              </a>
            </span>
          </template>

          <!-- 提交按钮区域 -->
          <template slot="menuForm" slot-scope="{size}">
            <el-button
                style="width: 100%; margin: 10px 0;"
                type="primary"
                :size="size"
                @click="$refs.form.submit()"
            >
              注册
            </el-button>
            <div style="text-align: center; margin-top: 10px;">
              <span>已有账号？</span>
              <el-button type="text" @click="$router.push('/login')">立即登录</el-button>
            </div>
          </template>
        </avue-form>
      </el-card>
    </div>
  </div>
</template>

<script>
import { setLocal } from '@/utils/localstorage.js';

export default {
  name: "Register",
  data() {
    return {
      data: {
        username: '',
        password: '',
        confirmPassword: '',
        agreeProtocol: false // 初始未勾选状态
      },
      option: {
        submitBtn: false,
        emptyBtn: false,
        column: [
          {
            label: '用户名',
            prop: 'username',
            span: 24,
            rules: [
              {required: true, message: "请输入用户名", trigger: "blur"},
              {min: 3, max: 20, message: "用户名长度在3-20个字符之间", trigger: "blur"}
            ]
          },
          {
            label: '密码',
            prop: 'password',
            type: 'password',
            span: 24,
            rules: [
              {required: true, message: "请输入密码", trigger: "blur"},
              {min: 6, max: 20, message: "密码长度在6-20个字符之间", trigger: "blur"}
            ]
          },
          {
            label: '确认密码',
            prop: 'confirmPassword',
            type: 'password',
            span: 24,
            rules: [
              {required: true, message: "请确认密码", trigger: "blur"},
              {validator: this.validatePassword, trigger: "blur"}
            ]
          },
          {
            label: '',
            prop: 'agreeProtocol',
            type: 'checkbox',
            span: 24,
            rules: [
              {required: true, message: "请阅读并同意所有协议后提交", trigger: ["change", "submit"]},
              {
                validator: (rule, value, callback) => {
                  if (!value) {
                    callback(new Error('请勾选协议'));
                  } else {
                    callback();
                  }
                },
                trigger: ["change", "submit"]
              }
            ],
            slot: true,
            labelWidth: '0px'
          }
        ]
      }
    };
  },
  mounted() {
    document.addEventListener('keyup', this.handleDocumentKeyup);
  },
  beforeDestroy() {
    document.removeEventListener('keyup', this.handleDocumentKeyup);
  },
  methods: {
    // 判断是否为移动端
    isMobile() {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent);
    },

    // 验证两次密码一致
    validatePassword(rule, value, callback) {
      if (value !== this.data.password) {
        callback(new Error('两次输入的密码不一致'));
      } else {
        callback();
      }
    },

    // 打开协议HTML页面
    openProtocol(htmlFileName) {
      try {
        // 协议HTML文件存放于public目录下的agreements文件夹
        const protocolUrl = `./agreements/${htmlFileName}`;
        const newWindow = window.open(
            protocolUrl,
            '_blank',
            'width=800,height=600,top=100,left=100,scrollbars=yes,resizable=yes'
        );

        if (!newWindow) {
          this.$message.warning({
            message: '浏览器已拦截协议窗口，请关闭弹窗拦截后重试',
            duration: 3000
          });
        }
      } catch (error) {
        console.error('打开协议失败：', error);
        this.$message.error('打开协议失败，请刷新页面重试');
      }
    },

    // 表单提交处理
    submit(form, done) {
      this.$refs.form.validate(valid => {
        if (valid) {
          // 二次确认协议勾选状态
          if (!this.data.agreeProtocol) {
            this.$message.error("请阅读并同意所有协议后提交");
            done();
            return;
          }

          // 执行注册逻辑
          setLocal('userInfo', { username: this.data.username });
          this.$message.success("用户注册成功，待审核中");
          done();
          // 可选项：注册成功后跳转登录页
          // setTimeout(() => this.$router.push('/login'), 1500);
        } else {
          // 校验失败处理
          if (!this.data.agreeProtocol) {
            this.$message.error("请阅读并同意所有协议后提交");
          }
          done();
        }
      });
    },

    // 表单内回车提交
    handleEnterKey() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submit();
        } else {
          this.$message.error("表单填写有误，请检查后提交");
        }
      });
    },

    // 全局回车提交处理
    handleDocumentKeyup(e) {
      if ((e.key === 'Enter' || e.keyCode === 13) && document.activeElement.tagName !== 'INPUT') {
        this.handleEnterKey();
      }
    }
  }
};
</script>

<style scoped>
.register-container {
  width: 100%;
  height: 100vh;
  background-image: url('~@/assets/img/backgroudImg/background.png');
  background-size: cover;
  background-position: center;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  box-sizing: border-box;
}

.register-wrapper {
  max-width: 400px;
  width: 100%;
}

.register-card {
  padding: 30px 25px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  background-color: #fff;
}

.register-form {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

/* 协议区域样式 */
.protocol-checkbox {
  margin-right: 8px;
  vertical-align: middle;
}

.protocol-text {
  font-size: 12px;
  color: #666;
  vertical-align: middle;
  line-height: 1.5;
}

.protocol-link {
  font-size: 12px;
  color: #409EFF;
  text-decoration: underline;
  cursor: pointer;
  margin: 0 2px;
}

.protocol-link:hover {
  color: #2d8cf0;
  text-decoration: none;
}

.protocol-separator {
  font-size: 12px;
  color: #666;
  margin: 0 4px;
}

/* 移动端适配 */
@media screen and (max-width: 768px) {
  .protocol-text, .protocol-link, .protocol-separator {
    font-size: 11px;
  }

  .protocol-text {
    display: inline-block;
    width: calc(100% - 24px);
  }
}

/* 表单样式调整 */
::v-deep .el-form-item__label {
  text-align: right;
  padding-right: 10px;
  font-size: 14px;
}

::v-deep .el-form-item--error .protocol-text {
  color: #F56C6C;
}

::v-deep .el-form-item__error {
  z-index: 10;
  padding-left: 24px;
}
</style>